const { createSlice } = require("@reduxjs/toolkit");

const kycSlice = createSlice({
  name: "kyc",
  initialState: {
    pendingSessionId: null,
    verificationStarted: false,
  },
  reducers: {
    setKycSession: (state, action) => {
      state.pendingSessionId = action.payload;
      state.verificationStarted = true;
    },
    clearKycSession: (state) => {
      state.pendingSessionId = null;
      state.verificationStarted = false;
    },
  },
});

export const { setKycSession, clearKycSession } = kycSlice.actions;

export default kycSlice.reducer;
